import React from 'react';
import { Drawer } from 'antd';
import { useAppSelector } from '@/store/hooks';
import AssessmentResults from './AssessmentAnswer';

type IDescriptionProps = {
  show: boolean;
  user_id: string;
  id: string;
  onClose: () => void;
};

const DrawerAssessment: React.FC<IDescriptionProps> = ({
  show,
  user_id,
  id,
  onClose
}) => {
  const assessments = useAppSelector(({ order }) => order.assessments);

  // Filter to show only the assessment for the specific id
  const selectedAssessment = assessments?.find(
    (assessment) => assessment.id === id
  );

  return (
    <Drawer
      width={640}
      placement="right"
      closable={false}
      onClose={onClose}
      open={show}
    >
      <div>
        <div
          className="flex justify-between items-center"
          style={{ marginBottom: 18 }}
        >
          <p className="site-description-item-profile-p font-semibold uppercase">
            Assessment Questions and Answers{' '}
            {selectedAssessment && `(${selectedAssessment.candidate_name})`}
          </p>
        </div>
        {selectedAssessment ? (
          <div key={selectedAssessment.id}>
            <AssessmentResults
              user_id={selectedAssessment.user_id}
              assessment_id={selectedAssessment.id}
            />
          </div>
        ) : (
          <p className="text-center text-gray-500">
            No assessment data found for this user.
          </p>
        )}
      </div>
    </Drawer>
  );
};

export default DrawerAssessment;
